import React from 'react';
import Me from '../../users/components/Me';

const DashboardView = () => (<Me />);

export default DashboardView;
